
export default class PageBrowserEvents
{
    constructor(targetElement)
    {
        this.lastBrowserEvent = {};
        this.browserEventHistory = [];
        this.initBrowserEvents();
    }

    _smallObj(t, oo, lvl = 0)
    {
        lvl++;
        if (lvl > 3) return t;

        for (let dd in oo)
        {
            const o = oo[dd];
            if (!o || typeof o == "number" || typeof o == "boolean" || typeof o == "string")
            {
                t += "__" + dd + ":" + o + "<br/>";
            }
            else
            if (Array.isArray(o))
            {
                t += "array<br/>";
            }
            else
            if (typeof o == "object")
            {
                t += "[" + typeof o + "] ";

                const constr = o.constructor;
                if (constr.name && constr.name !== "Function")
                {
                    t += constr.name;
                }
                t += "<br/>";

                if (constr.name == "TouchList" || constr.name == "Touch") t += this._smallObj("", o, lvl) || "";
            }
        }
        return t;
    }

    logEventObject(orig, e, html, lvl)
    {
        lvl = lvl || 0;
        if (lvl > 3) return "oops";
        html = html || "";

        for (const i in e)
        {
            if (i === "parent") continue;
            else if (!e[i] || typeof e[i] == "number" || typeof e[i] == "boolean" || typeof e[i] == "string")
            {
                html += "<tr><td>" + i + "</td><td style=\"width:100%\">";
                if (!this.lastBrowserEvent[e.type] || this.lastBrowserEvent[e.type][i] !== e[i]) html += "<b>";
                html += e[i];
                if (!this.lastBrowserEvent[e.type] || this.lastBrowserEvent[e.type][i] !== e[i]) html += "</b>";

                html += "</td></tr>";
            }
            else if (Array.isArray(e[i]))
            {
                let str = "";
                try
                {
                    str = JSON.stringify(e[i]);
                }
                catch (e2) {}
                html += "<tr><td>" + i + "</td><td>" + str + "</td></tr>";
            }
            else
            {
                if (!e[i].constructor) return;

                let t = "[" + typeof e[i] + "] ";

                const constr = e[i].constructor;
                if (constr.name && constr.name !== "Function")
                {
                    t += constr.name;
                }

                t += "<br/>";
                t += this._smallObj(t, e[i], 0);

                html += "<tr><td>" + i + "</td><td>" + t + "</td></tr>";
            }
        }

        this.lastBrowserEvent[e.type] = e;

        return html;
    }

    logBrowserEvent(e)
    {
        e.preventDefault();

        const maxHist = 50;
        this.browserEventHistory.unshift(e.type);
        if (this.browserEventHistory.length > maxHist) this.browserEventHistory.length = maxHist;
        let historyHtml = "";
        for (let i = 0; i < this.browserEventHistory.length; i++)
        {
            historyHtml += this.browserEventHistory[i] + "<br/>";
        }
        document.getElementById("history").innerHTML = historyHtml;

        let html = "";

        html += "<h3>" + e.type + "</h3><br/>";

        html += "<table>";
        html += this.logEventObject(e, e, "", 0);
        html += "</table>";

        document.getElementById("output").innerHTML = html;

        return false;
    }


    initBrowserEvents()
    {
        document.getElementById("results").innerText = "";

        window.addEventListener("load", this.logBrowserEvent.bind(this));
        window.addEventListener("gamepadconnected", this.logBrowserEvent.bind(this));
        window.addEventListener("DOMContentLoaded", this.logBrowserEvent.bind(this));

        window.addEventListener("gamepadconnected", this.logBrowserEvent.bind(this));
        window.addEventListener("gamepaddisconnected", this.logBrowserEvent.bind(this));


        document.addEventListener("keydown", this.logBrowserEvent.bind(this));
        document.addEventListener("keyup", this.logBrowserEvent.bind(this));
        document.addEventListener("scroll", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("focus", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("blur", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("contextmenu", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("mouseenter", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("mouseleave", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("mousemove", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("pointerenter", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("pointerleave", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("pointermove", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("mousedown", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("mouseup", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("pointerdown", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("pointerup", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("click", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("dblclick", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("wheel", this.logBrowserEvent.bind(this));

        document.getElementById("input").addEventListener("touchmove", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("touchstart", this.logBrowserEvent.bind(this));
        document.getElementById("input").addEventListener("touchend", this.logBrowserEvent.bind(this));
    }
}
